export enum TypeParams {
    ID = 'id',
    YEAR = 'year',
    DATE_FROM = 'date_from',
    DATE_TO = 'date_to'
}
